import { useField, useFormikContext } from 'formik'
import { ChannelOption } from 'components/Wizards/CampaignWizard/Types'
import { FormStatus } from '../Types'
import { LoadingSkeleton } from './LoadingSkeleton'
import { partition } from 'lodash'
import { DesignChannels } from './DesignChannels'
import { TextChannels } from './TextChannels'
import { ChannelsListProvider } from './ChannelsListContext/ChannelsListContext'
import Styles from './ChannelsList.module.scss'

export const ChannelsList = () => {
  const { status } = useFormikContext()
  const [{ value: channels }] = useField<ChannelOption[]>('channels')
  const [designChannels, textChannels] = partition(channels, (channel) => !!channel.width && !!channel.height)

  if (status === FormStatus.AutoFilling) {
    return <LoadingSkeleton />
  }

  return (
    <ChannelsListProvider>
      <div className={Styles.channelsList}>
        {designChannels.length > 0 && <DesignChannels channels={designChannels} />}
        {textChannels.length > 0 && <TextChannels channels={textChannels} />}
      </div>
    </ChannelsListProvider>
  )
}
